import React from "react";
import { useHistory } from "react-router-dom";
import { LocalStorageItem, RoutePath } from "../models/enums";
import "../styles/logoutFooter.css";

const LogoutFooter: React.FC = (): React.JSX.Element => {
  const history = useHistory();
  const onClickLogout = (): void => {
    localStorage.removeItem(LocalStorageItem.token);
    history.push(RoutePath.loginPage);
  };

  return (
    <div className="footer" data-testid="footer">
      <p onClick={onClickLogout} className="footer__buttonLogout" data-testid="buttonLogout">
        Выйти из аккаунта VK Teams
      </p>
    </div>
  );
};

export default LogoutFooter;
